import useScrollAnimation from '@/hooks/useScrollAnimation';

export default function InfoSection() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="info" className="relative py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div
        ref={ref}
        className={`max-w-4xl mx-auto transition-all duration-1000 ease-out ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
      >
        <div className="text-center mb-16">
          <p className="text-primary-500 font-sans text-xs tracking-[0.4em] mb-4">
            INFORMATION
          </p>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-800 mb-3 tracking-wider">
            店舗情報
          </h2>
          <div className="w-12 h-[1px] bg-secondary-400 mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-8">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100/70">
                <i className="ri-map-pin-line text-lg text-primary-500"></i>
              </div>
              <div>
                <h3 className="font-sans text-xs text-foreground-500 tracking-wider mb-1">住所</h3>
                <p className="text-foreground-800 text-sm leading-relaxed">
                  〒050-0083<br />
                  北海道室蘭市東町
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100/70">
                <i className="ri-train-line text-lg text-accent-500"></i>
              </div>
              <div>
                <h3 className="font-sans text-xs text-foreground-500 tracking-wider mb-1">最寄駅</h3>
                <p className="text-foreground-800 text-sm">
                  JR東室蘭駅より徒歩15分以内
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100/70">
                <i className="ri-phone-line text-lg text-secondary-500"></i>
              </div>
              <div>
                <h3 className="font-sans text-xs text-foreground-500 tracking-wider mb-1">電話番号</h3>
                <a
                  href="tel:07077860873"
                  className="text-foreground-800 text-sm hover:text-primary-500 transition-colors duration-300"
                >
                  070-7786-0873
                </a>
              </div>
            </div>
          </div>

          <div className="space-y-8">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100/70">
                <i className="ri-time-line text-lg text-primary-500"></i>
              </div>
              <div>
                <h3 className="font-sans text-xs text-foreground-500 tracking-wider mb-1">営業時間</h3>
                <p className="text-foreground-800 text-sm">
                  12:00 〜 翌2:00
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100/70">
                <i className="ri-calendar-check-line text-lg text-accent-500"></i>
              </div>
              <div>
                <h3 className="font-sans text-xs text-foreground-500 tracking-wider mb-1">定休日</h3>
                <p className="text-foreground-800 text-sm">
                  不定休（月曜日）
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100/70">
                <i className="ri-home-4-line text-lg text-secondary-500"></i>
              </div>
              <div>
                <h3 className="font-sans text-xs text-foreground-500 tracking-wider mb-1">部屋数</h3>
                <p className="text-foreground-800 text-sm">
                  完全個室 2部屋
                </p>
              </div>
            </div>
          </div>
        </div>

  
      </div>
    </section>
  );
}